var StarsModule = /** @class */ (function () {
    function StarsModule() {
    }
    return StarsModule;
}());
export { StarsModule };
